import { LanguageEnum } from "jadro-pico/enums/common/LanguageEnum.ts";
import { defineResources } from "./defineResources.ts";

export const AppsLauncherResources = defineResources({
  [LanguageEnum.CS]: {
    title: "Apky Pičo",
    buttonAriaLabel: "Apky Pičo",
    closeAriaLabel: "Zavřít",
  },
  [LanguageEnum.EN]: {
    title: "Pičo Apps",
    buttonAriaLabel: "Pičo Apps",
    closeAriaLabel: "Close",
  },
});
